import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore} from 'redux';

import App from './components/maps/App';
import reducers from './reducers';
// chrome redux devtools helper
import {composeWithDevTools} from 'redux-devtools-extension';
import * as actionCreators from './actions/index';

const composeEnhancers = composeWithDevTools({
    actionCreators,
    trace: true,
    traceLimit: 25,
})

const store = createStore(
    reducers,
    // initialize chrome redux devtools helper
    composeEnhancers()
);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.querySelector('#root')
);